import ConversationContent from '@/api/conversationContent';
import ListeningItem from '@/api/listeningItem';
import SpeakingContent from '@/api/speakingContent';
import { isEmpty } from 'lodash';

export async function saveListeningItemIPA(
  listeningItem: ListeningItem,
  transcription: string
) {
  if (!isEmpty(listeningItem.transcription)) {
    return false;
  }

  listeningItem.transcription = transcription;
  await listeningItem.save();
  return true;
}

export async function saveSpeakingContentIPA(
  speakingContent: SpeakingContent,
  transcription: string
) {
  if (!isEmpty(speakingContent.transcription)) {
    return false;
  }

  speakingContent.transcription = transcription;
  await speakingContent.save();
  return true;
}

export async function saveConversationContentIPA(
  conversationContent: ConversationContent,
  transcription: string
) {
  if (!isEmpty(conversationContent.transcription)) {
    return false;
  }

  conversationContent.transcription = transcription;
  await conversationContent.save();
  return true;
}
